import FilePathService from '@/apps/shared/services/filePath-service';

export async function safeRedirect(
    url: string,
    next?: any,
    router?: any
): Promise<void> {
    const fallbackRoute: any = { name: 'not-found' };
    const isSafe = await FilePathService.validateUrl(url);
    if (isSafe) {
        window.location.href = url;
    } else if (next) {
        next(fallbackRoute);
    } else if (router) {
        router.push(fallbackRoute);
    } else {
        window.location.href = '/notFound';
    }
}